import { useAtom, useAtomValue } from 'jotai';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Modal, Select, Text } from '@/lib/v2/components';

import { ButtonActions } from '@/src/modules/CampaignsModule/components/CampaignsModal/CreateEditCampaigns/components/ButtonActions';

import { useHandleEvents } from './hooks/useHandleEvents';
import { useMoveActions } from './hooks/useMoveActions';

import {
  atomDropdownCampaignList,
  atomTotalActionsSelectedRows,
} from '@/modules/CampaignsModule/atoms/campaignAtom';
import { atomToggleMoveActionsModal } from '@/modules/CampaignsModule/atoms/modalsCampaignAtom';
import { IFormMoveAction } from '@/modules/CampaignsModule/interfaces/CampaignActions';

const MoveActions = () => {
  const { t } = useTranslation();

  const { control, handleSubmit } = useForm<IFormMoveAction>();
  const { handleCloseModal, handleSubmitData, handleChangeCampaigns, loading } = useHandleEvents();
  const { loadingCampaign, VALIDATION_RULES } = useMoveActions();

  const [toggleMoveActionsModal] = useAtom(atomToggleMoveActionsModal);
  const totalActionsSelectedRows = useAtomValue(atomTotalActionsSelectedRows);
  const dropdownCampaignList = useAtomValue(atomDropdownCampaignList);

  return (
    <Modal open={toggleMoveActionsModal} onClose={handleCloseModal}>
      <div className="flex flex-col gap-2 divide-y">
        <header>
          <Text as="h3" fontWeight="medium" variant="sub-headline">
            {t('CAMPAIGN_ACTIONS_MAIN.MOVE_ACTIONS.title')}
          </Text>
        </header>
        <section className="flex w-full flex-col pt-6">
          <form
            autoComplete="off"
            id="createEditCampaigns"
            onSubmit={handleSubmit(handleSubmitData)}
          >
            <Select
              isRequired
              withSearch
              control={control}
              id="campaigns"
              isLoading={loadingCampaign}
              label={
                totalActionsSelectedRows > 1
                  ? t('CAMPAIGN_ACTIONS_MAIN.MOVE_ACTIONS.DROPDOWN.MULTIPLE.label')
                  : t('CAMPAIGN_ACTIONS_MAIN.MOVE_ACTIONS.DROPDOWN.SINGLE.label')
              }
              name="campaigns"
              options={dropdownCampaignList}
              placeholder={t('CAMPAIGN_ACTIONS_MAIN.MOVE_ACTIONS.DROPDOWN.placeholder')}
              rules={VALIDATION_RULES.campaigns}
              onChange={handleChangeCampaigns}
            />
            <ButtonActions
              disabledSubmitButton={loadingCampaign}
              isLoading={loading}
              textCancelButton={t('CAMPAIGN_ACTIONS_MAIN.EDIT_ACTIONS.cancelButton')}
              textSubmitButton={t('CAMPAIGN_ACTIONS_MAIN.EDIT_ACTIONS.successButton')}
              onClose={handleCloseModal}
            />
          </form>
        </section>
      </div>
    </Modal>
  );
};

export default MoveActions;
